import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Home from '@/views/Home'

export const constantRouterMap = [
  {
    path: '/',
    component: Home,
    redirect: '/home',
    children: [
      {
        path: '/home',
        component: () => import('@/views/baseInfo/agency_information')
      },
      {
        path: '/resetPsw',
        component: () => import('@/views/user/Update')
      }
    ]
  },
  {
    path: '/baseInfo',
    component: Home,
    children: [
      {
        path: '/baseInfo/agency',
        component: () => import('@/views/baseInfo/agency_information')
      },
      {
        path: '/baseInfo/host',
        component: () => import('@/views/baseInfo/host_information')
      }
    ]
  },
  {
    path: '/dashboard',
    component: Home,
    children: [
      {
        path: '/dashboard/agency_information',
        component: () => import('@/views/dashboard/agency_information')
      },
      {
        path: '/dashboard/daily_report',
        component: () => import('@/views/dashboard/daily_report')
      },
      {
        path: '/dashboard/hostess',
        component: () => import('@/views/dashboard/hostess')
      },
      {
        path: '/dashboard/hostess_income_detail',
        component: () => import('@/views/dashboard/hostess_income_detail')
      }
    ]
  },
  {
    path: '/report',
    component: Home,
    children: [
      {
        path: '/report/total_income',
        component: () => import('@/views/report/data_income')
      },
      {
        path: '/report/total_income_week',
        component: () => import('@/views/report/week_income')
      },
      {
        path: '/report/settlement_detail',
        component: () => import('@/views/report/settlement_income')
      }
    ]
  },
  {
    path: '/block',
    component: Home,
    children: [
      {
        path: '/block/block',
        component: () => import('@/views/Block')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/Login'),
    hidden: true
  }
]

export const async404 = [
  {
    path: '*',
    component: () => import('@/views/404'),
    hidden: true
  }
]

const router = new VueRouter({
  // base: process.env.BASE_URL,
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [...constantRouterMap, ...async404]
})

export default router
